export default "__VITE_ASSET__fKqh3TkP__"